"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaType = void 0;
var SchemaType;
(function (SchemaType) {
    /** String type. */
    SchemaType["STRING"] = "STRING";
    /** Number type. */
    SchemaType["NUMBER"] = "NUMBER";
    /** Integer type. */
    SchemaType["INTEGER"] = "INTEGER";
    /** Boolean type. */
    SchemaType["BOOLEAN"] = "BOOLEAN";
    /** Array type. */
    SchemaType["ARRAY"] = "ARRAY";
    /** Object type. */
    SchemaType["OBJECT"] = "OBJECT";
})(SchemaType = exports.SchemaType || (exports.SchemaType = {}));
